<!-- Форма слева, на десктопе справа — закреплённая боковая панель -->
<div class="calc-page">
<div class="calc-new">

  <!-- ── Вводный блок: зачем это и что получит пользователь ────────────────── -->
  <section class="intro">
    <span class="intro__eyebrow">{{ introEyebrowText }}</span>
    <h1 class="intro__title">{{ titleText }}</h1>
    <ul class="features">
      <li class="feature" *ngFor="let f of features; let i = index" [style.--i]="i">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>
        {{ f.title }}
      </li>
    </ul>
  </section>

  <form [formGroup]="calculationForm" (ngSubmit)="onSubmit()" novalidate>

    <!-- ── Способ ввода ──────────────────────────────────────────────────────── -->
    <div class="mode" role="tablist">
      <button
        type="button"
        role="tab"
        class="mode__btn"
        [class.mode__btn--active]="activeTab === 'manual'"
        [attr.aria-selected]="activeTab === 'manual'"
        (click)="switchTab('manual')"
      >
        <span class="mode__icon">
          <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M4 20h4L19 9a2.1 2.1 0 000-3l-1-1a2.1 2.1 0 00-3 0L4 16v4z M13.5 6.5l4 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </span>
        <span class="mode__text">
          <strong>{{ manualTabText }}</strong>
          <small>{{ manualHintText }}</small>
        </span>
      </button>
      <button
        type="button"
        role="tab"
        class="mode__btn"
        [class.mode__btn--active]="activeTab === 'invoice'"
        [attr.aria-selected]="activeTab === 'invoice'"
        (click)="switchTab('invoice')"
      >
        <span class="mode__icon">
          <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M7 3h7l5 5v13H7z M14 3v5h5 M10 13h6 M10 17h6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </span>
        <span class="mode__text">
          <strong>{{ invoiceTabText }}</strong>
          <small>{{ invoiceHintText }}</small>
        </span>
      </button>
    </div>

    <!-- ── Ручной ввод ───────────────────────────────────────────────────────── -->
    <section class="goods" *ngIf="activeTab === 'manual'">
      <div class="goods__head">
        <h2>{{ productsText }}</h2>
        <span class="goods__count">{{ countLabel }}</span>
      </div>

      <div formArrayName="products" class="goods__list">
        <article class="card good" *ngFor="let product of products.controls; let i = index" [formGroupName]="i">
          <header class="good__head">
            <span class="good__num">{{ i + 1 }}</span>
            <h3>{{ productText }} {{ i + 1 }}</h3>
            <button
              type="button"
              class="good__remove"
              *ngIf="products.length > 1"
              (click)="removeProduct(i)"
              [attr.aria-label]="removeText + ' ' + productText + ' ' + (i + 1)"
              [title]="removeText"
            >
              <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M5 7h14 M10 7V5h4v2 M7 7l1 12h8l1-12 M10 11v5 M14 11v5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </button>
          </header>

          <div class="field">
            <label [attr.for]="'good-name-' + i">{{ productNameText }} <span class="req" aria-hidden="true">*</span></label>
            <input
              [id]="'good-name-' + i"
              type="text"
              formControlName="nameOriginal"
              class="input"
              [class.is-invalid]="isInvalid(product, 'nameOriginal')"
              [placeholder]="productNamePlaceholderText"
              autocomplete="off"
            />
            <p class="field__error" *ngIf="isInvalid(product, 'nameOriginal')">{{ nameRequiredText }}</p>
          </div>

          <div class="field">
            <label [attr.for]="'good-cost-' + i">{{ productCostText }} <span class="req" aria-hidden="true">*</span></label>
            <div class="cost">
              <input
                [id]="'good-cost-' + i"
                type="number"
                inputmode="decimal"
                formControlName="productCost"
                class="input cost__amount"
                [class.is-invalid]="isInvalid(product, 'productCost')"
                step="0.01"
                min="0.01"
                placeholder="0"
              />
              <select formControlName="currencyCode" class="input cost__currency" [attr.aria-label]="currencyText">
                <option *ngFor="let c of productCurrencies" [value]="c">{{ c }}</option>
              </select>
            </div>
            <p class="field__error" *ngIf="isInvalid(product, 'productCost')">{{ costRequiredText }}</p>
            <p class="field__hint" *ngIf="!isInvalid(product, 'productCost') && getProductCostKzt(product) !== null && getProductCostKzt(product)! > 0">
              {{ inKztText }}: ≈ {{ formatKzt(getProductCostKzt(product)) }} ₸
            </p>
          </div>

          <div class="field">
            <label [attr.for]="'good-scope-' + i">{{ applicationScopeText }} <span class="optional">· {{ optionalText }}</span></label>
            <textarea
              [id]="'good-scope-' + i"
              formControlName="applicationScope"
              class="input input--area"
              rows="3"
              maxlength="300"
              [class.is-invalid]="isInvalid(product, 'applicationScope')"
              [placeholder]="applicationScopeHintText"
              [attr.aria-describedby]="'good-scope-note-' + i"
            ></textarea>
            <p class="field__error" *ngIf="isInvalid(product, 'applicationScope')">{{ maxLength300Text }}</p>
            <p class="field__hint field__hint--note" [id]="'good-scope-note-' + i" *ngIf="!isInvalid(product, 'applicationScope')">{{ applicationScopeNoteText }}</p>
          </div>
        </article>
      </div>

      <!-- Итог под товарами — от двух товаров; при одном он повторял бы сумму под полем -->
      <p class="goods__total" *ngIf="pricedProductsCount > 1">
        <span>{{ goodsTotalLabel }}</span>
        <strong>≈ {{ formatKzt(goodsTotalKzt) }} ₸</strong>
      </p>

      <button type="button" class="add-good" *ngIf="products.length < maxCustomsProducts" (click)="addProductAndFocus()">
        <svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path d="M10 4v12 M4 10h12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        {{ addProductText }}
      </button>
      <p class="limit-note" *ngIf="products.length >= maxCustomsProducts">{{ maxProductsHintText }}</p>
    </section>

    <!-- ── Загрузка инвойса ──────────────────────────────────────────────────── -->
    <section class="upload" *ngIf="activeTab === 'invoice'">
      <input type="file" accept="application/pdf,.pdf" #invoiceInput hidden (change)="onInvoiceSelected($event)" />

      <div
        class="dropzone"
        [class.dropzone--active]="dragActive"
        [class.dropzone--filled]="invoiceFile"
        role="button"
        tabindex="0"
        [attr.aria-label]="dropzoneTitleText"
        (click)="invoiceInput.click()"
        (keydown.enter)="invoiceInput.click()"
        (keydown.space)="$event.preventDefault(); invoiceInput.click()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        <ng-container *ngIf="!invoiceFile; else fileChosen">
          <span class="dropzone__icon">
            <svg viewBox="0 0 24 24" width="30" height="30" aria-hidden="true"><path d="M12 16V5 M7.5 9.5L12 5l4.5 4.5 M5 15v3a2 2 0 002 2h10a2 2 0 002-2v-3" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
          <strong class="dropzone__title">{{ dropzoneTitleText }}</strong>
          <span class="dropzone__hint">{{ dropzoneHintText }}</span>
          <span class="dropzone__btn">{{ invoiceChooseFileText }}</span>
        </ng-container>
        <ng-template #fileChosen>
          <span class="file">
            <span class="file__icon">
              <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M7 3h7l5 5v13H7z M14 3v5h5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
            <span class="file__info">
              <strong class="file__name">{{ invoiceFile?.name }}</strong>
              <small>{{ formatFileSize(invoiceFile!.size) }}</small>
            </span>
            <span class="file__actions">
              <button type="button" class="file__btn" (click)="invoiceInput.click(); $event.stopPropagation()">{{ fileReplaceText }}</button>
              <button type="button" class="file__btn file__btn--danger" (click)="removeInvoice($event)">{{ fileRemoveText }}</button>
            </span>
          </span>
        </ng-template>
      </div>

      <ol class="upload__steps">
        <li><span>1</span>{{ uploadStep1Text }}</li>
        <li><span>2</span>{{ uploadStep2Text }}</li>
        <li><span>3</span>{{ uploadStep3Text }}</li>
      </ol>
    </section>

    <!-- ── Название расчёта (необязательно, спрятано под ссылку) ──────────────── -->
    <div class="title-field">
      <button type="button" class="desc__toggle" *ngIf="!titleOpen" (click)="openTitle()">
        {{ addTitleText }}
      </button>
      <div class="card" *ngIf="titleOpen">
        <div class="field">
          <label for="calc-title">{{ calculationTitleText }} <span class="optional">· {{ optionalText }}</span></label>
          <input id="calc-title" type="text" formControlName="title" class="input" autocomplete="off" [placeholder]="titlePlaceholderText" />
        </div>
      </div>
    </div>

    <p class="form-error" *ngIf="error" role="alert">
      <svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path d="M10 6v5 M10 14.2v.1 M10 2.5l8 14H2z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
      {{ error }}
    </p>

    <p class="disclaimer">
      {{ detailedAssessmentHintText }}
    </p>

    <!-- Согласие с документами: на телефоне — над прилипающей панелью, на десктопе — под кнопкой -->
    <app-legal-consent mode="notice" class="consent consent--mobile"></app-legal-consent>

    <!-- ── Панель действий (на телефоне прилипает к низу экрана) ──────────────── -->
    <div class="actions">
      <button type="button" class="btn btn--ghost" (click)="onCancel()" [disabled]="submitting">{{ cancelText }}</button>
      <button type="submit" class="btn btn--cta" [disabled]="submitting">
        {{ submitting ? submittingText : submitText }}
      </button>
    </div>

    <app-legal-consent mode="notice" class="consent consent--desktop"></app-legal-consent>
  </form>
</div>

  <!-- ── Боковая панель: что получит пользователь, как это работает, помощь ── -->
  <aside class="calc-aside">
    <section class="aside-card">
      <h2 class="aside-card__title">{{ asideTitleText }}</h2>
      <ul class="aside-list">
        <li *ngFor="let item of asideItems">{{ item }}</li>
      </ul>
    </section>

    <section class="aside-card">
      <h2 class="aside-card__title">{{ asideStepsTitleText }}</h2>
      <ol class="aside-steps">
        <li *ngFor="let step of asideSteps; let i = index"><span>{{ i + 1 }}</span>{{ step }}</li>
      </ol>
    </section>

    <section class="aside-card aside-card--help">
      <h2 class="aside-card__title">{{ asideHelpTitleText }}</h2>
      <p>{{ asideHelpText }}</p>
      <a class="aside-help-btn" [href]="asideWhatsappUrl" target="_blank" rel="noopener noreferrer">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2zm5.8 14.06c-.24.69-1.42 1.32-1.95 1.36-.5.05-.97.23-3.28-.68-2.78-1.1-4.55-3.95-4.69-4.13-.13-.18-1.12-1.49-1.12-2.84s.71-2.01.96-2.29c.25-.27.55-.34.73-.34l.52.01c.17.01.39-.06.61.47.24.56.79 1.92.86 2.06.07.14.11.3.02.48-.09.18-.14.3-.27.46-.14.16-.29.36-.41.48-.14.14-.28.29-.12.56.16.27.71 1.17 1.52 1.9 1.05.93 1.93 1.22 2.2 1.36.27.14.43.11.59-.07.16-.18.68-.79.86-1.07.18-.27.36-.23.61-.14.25.09 1.59.75 1.86.89.27.14.45.2.52.32.07.11.07.66-.17 1.35z"/></svg>
        {{ asideHelpBtnText }}
      </a>
    </section>
  </aside>
</div>
